import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Modal, Input} from "antd"
const { TextArea } = Input;

class ChangeNoteModal extends Component {
    _handleChangeNote = e => {
        const {onChangeNote} = this.props
        const noteContent = e.target.value
        if (typeof onChangeNote === 'function') {
            onChangeNote(noteContent)
        }
    }

    render() {
        const {isOpen, onClose, note, loading, error, isUpdated, onUpdateNote, errorUpdate} = this.props

        return (
            <div className='ChangePartnerModal'>
                <Modal
                    title="Thay đổi ghi chú"
                    visible={isOpen}
                    onCancel={onClose}
                    footer={[
                        <div key='select' className='d-flex justify-content-between align-items-center'>
                            <Button key="back" onClick={onClose}>
                                Hủy
                            </Button>
                            <Button key="submit" type="primary" disabled={!isUpdated} loading={loading}
                                    onClick={onUpdateNote}>
                                Thay đổi
                            </Button>
                        </div>
                    ]}
                >
                    <div>
                        {/* <input className='form-control' value={note}
                               onChange={this._handleChangeNote}/> */}
                        <TextArea rows={4} placeholder="Nhập ghi chú" value={note} onChange={this._handleChangeNote}/>

                        {error && <Alert message={error} type='error' className='mt-3'/>}
                        {errorUpdate && <Alert message={errorUpdate} type='error' className='mt-3'/>}
                    </div>
                </Modal>
            </div>
        )
    }
}

ChangeNoteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    note: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
    isUpdated: PropTypes.bool,
    onUpdateName: PropTypes.func.isRequired,
    errorUpdate: PropTypes.string
}

export default ChangeNoteModal
